import React, { useEffect, useState } from 'react';
import '../../css/notifications.css';
import { fetchNotifications } from "../../services/notificationsService";

const Notifications = () => {
    const [notifications, setNotifications] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const loadNotifications = async () => {
            try {
                const data = await fetchNotifications();
                setNotifications(data);
            } catch (err) {
                setError('Failed to load notifications.');
            } finally {
                setLoading(false);
            }
        };

        loadNotifications();
    }, []);

    const formatTimeAgo = (timestamp) => {
        const now = new Date();
        const notificationDate = new Date(timestamp);
        const diffInMs = now - notificationDate;
        const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60));
        const diffInDays = Math.floor(diffInHours / 24);

        if (diffInHours < 1) return "Just now";
        if (diffInHours < 24) return `${diffInHours} hours ago`;
        return `${diffInDays} days ago`;
    };

    return (
        <div className="main-notifications-container">
            <h2 className="main-notifications-title">Notifications</h2>

            {loading ? (
                <div className="main-notifications-loading">Loading...</div>
            ) : error ? (
                <div className="main-notifications-error">{error}</div>
            ) : notifications.length === 0 ? (
                <p className="main-notifications-empty">You have no notifications.</p>
            ) : (
                <ul className="main-notifications-list">
                    {notifications.map((notif, index) => (
                        <React.Fragment key={notif.id}>
                            <li className={`main-notification-item ${notif.is_read ? 'read' : 'unread'}`}>
                                {notif.subscriber_image_url && (
                                    <img
                                        className="main-notification-image"
                                        src={notif.subscriber_image_url}
                                        alt={`${notif.subscriber_name}'s profile`}
                                    />
                                )}
                                <div className="main-notification-text">
                                    <strong className="main-notification-title">{notif.title}</strong>
                                    <p className="main-notification-message">{notif.message}</p>
                                    <small className="main-notification-time">
                                        {formatTimeAgo(notif.created_at)}
                                    </small>
                                </div>
                                {!notif.is_read && (
                                    <button
                                        className="mark-read-button"
                                    >
                                        Mark as Read
                                    </button>
                                )}
                            </li>
                            {index !== notifications.length - 1 && <hr className="menu-separator" />}
                        </React.Fragment>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default Notifications;